/**
 * Global constants for the TPOS application
 * This file contains shared constants that can be used across different packages
 */

// Branding constants
export const DEFAULT_PHARMACY_NAME = 'Fuze Health'

// Transfer template constants
export const DEFAULT_FROM_PHARM_LOCATION = 'Fuze Health'
export const DEFAULT_TO_PHARM_LOCATION = 'Fuze Health'
